export const convertThousandIntoKilo = (value: number) => {
  if (value >= 1000) {
    const roundedValue = (value / 1000).toFixed(1);
    return `${roundedValue}k`;
  }
  return value.toString();
};
